<div class="row" style="margin-top: 100px;">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<section style="overflow-x: hidden;">
  <div>
  <img
    class="css-z1tvno"
    src="assets/img/walpaper.jpeg"
    alt="top-bg"
    style="
      display: block;
      position: absolute;
      width: 100%;
      height: 56vh;
      object-fit: cover;
      
      font-size: 14px;
    "
  />
  <div>
  <h1
  class="text-why-sukanda"
  style="
    font-size: 64px;
    position: relative;
    font-weight: 500;
    text-align: center;
    

    bottom: 0; /* At the bottom. Use top:0 to append it to the top */
  background: rgb(0, 0, 0); /* Fallback color */
  background: rgba(0, 0, 0, 0.5); /* Black background with 0.5 opacity */
  color: #f1f1f1; /* Grey text */
  width: 100%; /* Full width */
  padding: 20px; /* Some padding */
  "
> Sukanda Onelink ?
</h1>
</div>
</div>
</section>
<section
  style="
    padding-top: 300px;
    padding-bottom: 64px;
    position: relative;
    display: block;
    overflow-x: hidden;
  "
>
  <div
    style="
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: auto;
      margin-right: auto;
    "
  >
  </div>
</section>
<section style="display: block; overflow-x: hidden;">
  <div class="row" style="width: 100%;">
   
    <!-- <h1
      class="text-why-sukanda"
      style="
        font-size: 64px;
        position: relative;
        color: #fffafa;
        font-weight: 500;
        text-align: center;
        
      "
    > Sukanda Onelink ?
    </h1> -->
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 60px; padding-right: 60px;margin-top: -150px;">
    <div class="col-sm-12">
      <div style="font-size: 32px;
      line-height: 1.41;
      color: #0a0a0a;
      font-weight: 800;
      ">
        <p>Tentang Sukanda Onelink</p>
      </div>
      <br />
      <div>
        Sukanda Onelink adalah platform e-commerce dari Sukanda Djaya untuk para customer di seluruh cabang yang ada di Indonesia.
      </div>
      <br />
      <div>
        www.sukandaonelink.com
      </div>
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 60px; padding-right: 60px;">
    <div class="col-sm-12">
      <div style="font-size: 32px;
      line-height: 1.41;
      color: #0a0a0a;
      font-weight: 800;
      ">
        <p>Sukanda Onelink bisa didapatkan melalui</p>
      </div>
    </div>
  </div>
      <br />
      <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 60px; padding-right: 60px;">
        <div class="col-sm-6">
          <div style="font-size: 32px;
          line-height: 1.41;
          color: #0a0a0a;
          font-weight: 800;
          ">
          </div>
          <br />
          <div class="col-sm-6" style=" margin-top: -26px;">
            <img
            class="logo-img-x forminlinemargin"
            src="assets/img/Picture2.png"
            style="max-width: 100%; height: auto;"
          />
          </div>
        </div>
        <div class="col-sm-6">
          <img
            class="logo-img-x forminlinemargin"
            src="assets/img/Picture1.png"
            style="max-width: 100%; height: auto;"
          />
        </div>
      <div class="col-sm-6">
        <div style="font-size: 32px;
        color: #0a0a0a;
        font-weight: 800;
        ">
        </div>
        <br />
        <div class="col-sm-6" style="margin-top: -19px;">
          <img
          class="logo-img-x forminlinemargin"
          src="assets/img/Capture2.png"
          style="width: 55%; height: auto;"
        />
        </div>
      </div>
      <div class="col-sm-6">
        <img
          class="logo-img-x forminlinemargin"
          src="assets/img/Capture1.png"
          style="max-width: 100%; height: auto;"
        />
      </div>
    </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
</section>
